import * as types from "../actions/actionTypes";
import { getAllDocumentsResponse, getDocumentByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const documentEntity = createEntitySagas({
  entity: "document",
  endpoint: "documents",
  label: "Document",
  scope: "company",
  computedFields: ["brandName","uploadedBy"],
  selectSlice: (state) => state.document,
  listKey: "documents",
  types: {
    getAll: types.GET_ALL_DOCUMENTS,
    getById: types.GET_DOCUMENT_BY_ID,
    create: types.CREATE_DOCUMENT,
    update: types.UPDATE_DOCUMENT,
    remove: types.DELETE_DOCUMENT,
  },
  actions: { getAllResponse: getAllDocumentsResponse, getByIdResponse: getDocumentByIdResponse },
});

export const documentSaga = documentEntity.watcher;
